import {
  rwPassengersData,
  rwPassengersDataTypes,
} from '../../entities/rw-passengers-data';

export const CYRILLIC_ONLY_DOC_TYPES: rwPassengersDataTypes.DocumentType[] = [
  rwPassengersData.config.documentTypes.ID,
  rwPassengersData.config.documentTypes.BIRTH_CERT,
  rwPassengersData.config.documentTypes.MILITARY_ID,
  rwPassengersData.config.documentTypes.ID_WITHOUT_CITIZENSHIP,
  rwPassengersData.config.documentTypes.ID_LOSS_CERT,
  rwPassengersData.config.documentTypes.RELEASE_CERT,
  rwPassengersData.config.documentTypes.RESIDENT_CARD,
];

export const LATIN_ONLY_DOC_TYPES: rwPassengersDataTypes.DocumentType[] = [
  rwPassengersData.config.documentTypes.PASSPORT_UZ,
];

export const RU_EN_ONLY_DOC_TYPES: rwPassengersDataTypes.DocumentType[] = [
  rwPassengersData.config.documentTypes.PASSPORT_KZ,
];
